import { AnyExtension, mergeAttributes, Node } from '@tiptap/core';
import { InlineNodes, NodeGroup } from '../available-extensions';

/**
 * Schema-only twin of the Angular MentionNodeComponent — prevents TipTap from dropping
 * unregistered nodes during HTML serialisation (PDF generation).
 */
export const mentionSerialisation = Node.create({
  name: InlineNodes.Mention,
  group: NodeGroup.Inline,
  inline: true,
  defining: true,
  atom: true,
  selectable: true,
  isolating: true,

  addAttributes() {
    return {
      key: { default: undefined },
      path: { default: undefined },
      type: { default: undefined },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { role: 'mention' })];
  },

  parseHTML() {
    return [
      {
        tag: 'span[role="mention"]',
        getAttrs: (dom) => {
          if (!(dom instanceof HTMLElement)) {
            return false;
          }
          return {
            key: dom.getAttribute('key'),
            path: dom.getAttribute('path'),
            type: dom.getAttribute('type'),
          };
        },
      },
    ];
  },
}) as AnyExtension;
